import { useRouteContext } from "@tanstack/react-router";
import { useCallback, useEffect } from "react";

declare global {
	interface Window {
		$chatwoot?: {
			setUser: (id: string, userData: Record<string, string>) => void;
			setCustomAttributes: (attrs: Record<string, string>) => void;
		};
	}
}

export function ChatwootListerner() {
	const { session, club } = useRouteContext({ from: "__root__" });

	const updateUser = useCallback(() => {
		if (session?.user) {
			// Build the user object with only the fields we have
			const userData: Partial<
				Record<"email" | "name" | "phone_number", string>
			> = {};

			if (session?.user?.email) {
				userData.email = session?.user?.email;
			}

			if (session?.user?.displayName) {
				userData.name = session?.user?.displayName;
			}

			// Only call setUser if we have at least email
			if (session?.user?.email) {
				window.$chatwoot?.setUser(session?.user?.id, userData);
			}

			// Custom attributes - these are "hidden" from the user
			// scarf_email will ALWAYS be the real logged-in email
			window.$chatwoot?.setCustomAttributes({
				user_role: club?.permissions?.some((p) => p.slug === "CLUB_ADMIN")
					? "admin"
					: club?.permissions?.some((p) => p.slug === "MODERATOR")
						? "moderator"
						: "user",
				scarf_email: session?.user?.email, // The REAL email, can't be changed by user
			});
		}
	}, [session, club]);

	useEffect(() => {
		window.addEventListener("chatwoot:ready", updateUser);

		return () => {
			window.removeEventListener("chatwoot:ready", updateUser);
		};
	}, [updateUser]);

	useEffect(() => {
		// @ts-expect-error
		if (session && window.$chatwoot) {
			updateUser();
		}
	}, [session, updateUser]);

	return null;
}
